var render = function render(){var _vm=this,_c=_vm._self._c;return _c('error-boundary',[_c('router-view'),_c('q-loader',{attrs:{"is-loading":_vm.isLoading}}),_c('offline',{on:{"detected-condition":_vm.handleConnectivityChange}}),_c('not-supported-browser-modal'),_c('microneedling-validation-modals'),_c('v-modal-target',{attrs:{"name":"root-modal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }